import { StickyFooterProp } from '../pages/components/StickyFooter';

export const companyName: StickyFooterProp = {
  companyLinkName: 'Barbers Ltd',
};
